// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  appName: "text-editor-web",
  production: false,
  env: "local",
  baseUrl: "http://43.227.132.104:7777",
  sortCall: "/sort",
  searchCall: "/search",
  indexCall: "/index",
  concordanceCall: "/concordance",
  extractorCall: "/extractor"
};